<template>
  <div class="aac-wrap">

    <div class="aac-header">
      <div class="urgences-group">
        <button class="urgences-btn" :class="{ 'urgences-btn--active': urgencesActive }" type="button" @click="toggleUrgences">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          Urgences
          <span class="urgences-count" v-if="urgencesCount > 0">{{ urgencesCount }}</span>
        </button>

        <button class="rdvp-btn" :class="{ 'rdvp-btn--active': rdvpNonValideActive }" type="button" @click="toggleRdvpNonValide">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          RDVP non validé
          <span class="rdvp-count" v-if="rdvpNonValideCount > 0">{{ rdvpNonValideCount }}</span>
        </button>
      </div>

      <div class="aac-filters" v-if="!urgencesActive && !rdvpNonValideActive">
        <div class="select-wrap">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
          </svg>
          <select v-model="filtre" class="form-select" @change="onFilterChange">
            <option value="tous">Tous les RDV</option>
            <option value="rdvp">RDVp à programmer</option>
            <option value="rdvp1">RDVp1 à programmer</option>
            <option value="rdvp2">RDVp2 à programmer</option>
          </select>
        </div>

        <div class="select-wrap">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="9"/>
          </svg>
          <select v-model="filtreCode" class="form-select" @change="onFilterChange">
            <option value="null">Code : tous</option>
            <option value="true">Code obtenu</option>
            <option value="false">Code non obtenu</option>
          </select>
        </div>
      </div>
    </div>

    <div class="aac-table-scroll">
      <DataTable :value="eleves" tableStyle="width: 100%" :rows="10" @click="onSelected" selectionMode="single" v-model:selection="selectedEleve">
        <Column field="nom" header="Nom"></Column>
        <Column header="Niveau">
          <template #body="slotProps">{{ slotProps.data.niveau }}%</template>
        </Column>
        <Column header="H à pgmer">
          <template #body="slotProps">{{ slotProps.data.heureApgmer }}h</template>
        </Column>
        <Column header="Solde" v-if="!rdvpNonValideActive">
          <template #body="slotProps">{{ slotProps.data.solde }}€</template>
        </Column>
        <Column header="RDVp">
          <template #body="slotProps">{{ slotProps.data.dateRdvp || '—' }}</template>
        </Column>
        <Column header="RDVp1 / RDVp2">
          <template #body="slotProps">
            <div class="rdvp-cell">
              <span :class="{ 'date-theorique': slotProps.data.dateRdvp1Theorique }">
                RDVp1 : {{ slotProps.data.dateRdvp1 || '—' }}
              </span>
              <span :class="{ 'date-theorique': slotProps.data.dateRdvp2Theorique }">
                RDVp2 : {{ slotProps.data.dateRdvp2 || '—' }}
              </span>
            </div>
          </template>
        </Column>
        <Column header="Code" v-if="!rdvpNonValideActive">
          <template #body="slotProps">
            <span class="code-badge" :class="slotProps.data.codeObtenu ? 'code-obtenu' : 'code-non-obtenu'">
              {{ slotProps.data.codeObtenu ? 'Obtenu' : 'Non obtenu' }}
            </span>
          </template>
        </Column>
        <Column header="Action" v-if="rdvpNonValideActive" bodyStyle="text-align:center">
          <template #body="slotProps">
            <button class="valider-rdvp-btn" type="button" @click.stop="validerRdvp(slotProps.data)">
              VALIDER RDVP
            </button>
          </template>
        </Column>
      </DataTable>
    </div>

    <Paginator
      :rows="10"
      :totalRecords="total"
      @page="onPaginate"
    ></Paginator>

  </div>
</template>

<script>

export default {

  props: [
    "putSelectEleve",
  ],

  data() {
    return {
      filtre: "tous",
      filtreCode: "null",
      urgencesActive: false,
      urgencesCount: 0,
      rdvpNonValideActive: false,
      rdvpNonValideCount: 0,
      eleves: [],
      total: 0,
      selectedEleve: null,
    };
  },

  mounted() {
    this.getEleves(0);
    this.getUrgencesCount();
    this.getRdvpNonValideCount();
  },

  methods: {

    onSelected() {
      this.$emit("putSelectEleve", this.selectedEleve);
      this.$store.commit('setShowSearchEleve', true);
      this.$store.commit('setPlanningSelectChoice', 'RESA');
      this.$store.commit('setModeResa', 'RESA ELEVE');
      this.$emit("changeDisplayApointment", true);
    },

    onFilterChange() {
      this.getEleves(0);
    },

    refresh() {
      this.getEleves(0);
      this.getUrgencesCount();
      this.getRdvpNonValideCount();
    },

    onPaginate(e) {
      this.getEleves(e.first);
    },

    toggleUrgences() {
      this.urgencesActive = !this.urgencesActive;
      if (this.urgencesActive) {
        this.rdvpNonValideActive = false;
      }
      this.getEleves(0);
    },

    toggleRdvpNonValide() {
      this.rdvpNonValideActive = !this.rdvpNonValideActive;
      if (this.rdvpNonValideActive) {
        this.urgencesActive = false;
      }
      this.getEleves(0);
    },

    getEleves(offset) {
      if (this.urgencesActive) {
        this.getElevesUrgences(offset);
      } else if (this.rdvpNonValideActive) {
        this.getElevesRdvpNonValide(offset);
      } else {
        this.getElevesEnCours(offset);
      }
    },

    getElevesEnCours(offset) {
      window.api
        .get(
          "/aac/eleves/encours/" +
            this.$store.state.user.agence.id +
            "/" +
            offset +
            "/" +
            this.filtre +
            "/" +
            this.filtreCode,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.eleves = response.data.eleves;
          this.total = response.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getUrgencesCount() {
      window.api
        .get(
          "/aac/eleves/heuresapgmer/count/" +
            this.$store.state.user.agence.id,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.urgencesCount = response.data.count;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getElevesUrgences(offset) {
      window.api
        .get(
          "/aac/eleves/heuresapgmer/" +
            this.$store.state.user.agence.id +
            "/" +
            offset,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.eleves = response.data.eleves;
          this.total = response.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getRdvpNonValideCount() {
      window.api
        .get(
          "/aac/eleves/rdvpapreparer/count/" +
            this.$store.state.user.agence.id,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.rdvpNonValideCount = response.data.count;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    validerRdvp(eleve) {
      window.api
        .put(
          "/eleve/" + eleve.id + "/aac/rdvp",
          {},
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          this.refresh();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getElevesRdvpNonValide(offset) {
      window.api
        .get(
          "/aac/eleves/rdvpapreparer/" +
            this.$store.state.user.agence.id +
            "/" +
            offset,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
          this.eleves = response.data.eleves;
          this.total = response.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },

};
</script>

<style scoped>

.aac-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 95%;
  margin: 0 auto;
}

.aac-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 14px 18px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}

.aac-filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.urgences-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.urgences-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #dc2626;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.urgences-btn--active .urgences-count {
  background: rgba(255, 255, 255, .25);
  color: #fff;
}

.urgences-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fef2f2;
  color: #dc2626;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background .15s, border-color .15s;
}

.urgences-btn:hover {
  background: #fee2e2;
  border-color: #fca5a5;
}

.urgences-btn--active {
  background: #dc2626;
  border-color: #dc2626;
  color: #fff;
}

.urgences-btn--active:hover {
  background: #b91c1c;
  border-color: #b91c1c;
}

.rdvp-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #dc2626;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.rdvp-btn--active .rdvp-count {
  background: rgba(255, 255, 255, .25);
  color: #fff;
}

.rdvp-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 16px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fef2f2;
  color: #dc2626;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background .15s, border-color .15s;
}

.rdvp-btn:hover {
  background: #fee2e2;
  border-color: #fca5a5;
}

.rdvp-btn--active {
  background: #dc2626;
  border-color: #dc2626;
  color: #fff;
}

.rdvp-btn--active:hover {
  background: #b91c1c;
  border-color: #b91c1c;
}

.select-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.select-wrap svg {
  position: absolute;
  left: 10px;
  color: #94a3b8;
  pointer-events: none;
}

.form-select {
  padding: 9px 32px 9px 32px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 10px center;
  -webkit-appearance: none;
  color: #1a1f2e;
  cursor: pointer;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
}

.form-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, .08);
}

.rdvp-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
}

.date-theorique {
  font-style: italic;
  color: #94a3b8;
}

.code-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.code-obtenu {
  background: #e8f7f1;
  color: #1a9e6e;
}

.code-non-obtenu {
  background: #fff1f2;
  color: #f43f5e;
}

.aac-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.valider-rdvp-btn {
  padding: 6px 10px;
  border: none;
  border-radius: 8px;
  background: #1a9e6e;
  color: #fff;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .02em;
  cursor: pointer;
  white-space: nowrap;
  transition: background .15s;
}

.valider-rdvp-btn:hover {
  background: #158058;
}

</style>
